import { Button, SourceDataIcon } from '@lokalise/louis'
import baseProfile from '../../../../assets/baseProfile.svg'
import { AI_PROFILES_DOCUMENTATION_URL } from '../../../../constants/url'
import { DescriptionWithIcon } from '../../../DescriptionWithIcon/DescriptionWithIcon'
import {
  StepContainer,
  StepContents,
  StepFooter,
  StepRSP,
  StepSubtitle,
  StepTitle,
  StepTitleContainer,
} from '../../../Step/Step'
import { StyledLink } from '../../../StyledLink/StyledLink'
import styles from './BaseProfileOverviewStep.module.css'

type BaseProfileOverviewStepProps = {
  name: string
  onNext: () => void
  onClose: () => void
}

export const BaseProfileOverviewStep = ({
  name,
  onNext,
  onClose,
}: BaseProfileOverviewStepProps) => (
  <StepContainer>
    <StepContents>
      <StepTitleContainer>
        <StepTitle>{name} edit guide</StepTitle>
        <StepSubtitle>
          This profile is used by default in all projects that include AI suggestions, AI tasks, AI
          scoring, or AI automations. Need more info? See the{' '}
          <StyledLink href={AI_PROFILES_DOCUMENTATION_URL} rel="noreferrer" target="_blank">
            docs.
          </StyledLink>
        </StepSubtitle>
      </StepTitleContainer>
      <div className="flex-col gap-4">
        <h3 className={styles.stepsContainerHeading}>Overview</h3>
        <DescriptionWithIcon
          title="One step - Select profile's basics"
          description="Modifying the profile's basic settings allows you to configure either routing or a specific LLM for the profile. This configuration will impact all projects utilizing Pro AI."
          icon={<SourceDataIcon size="16px" />}
        />
      </div>
      <StepFooter>
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onNext} variant="primary">
          Next
        </Button>
      </StepFooter>
    </StepContents>
    <StepRSP>
      <img alt="overview" src={baseProfile} />
    </StepRSP>
  </StepContainer>
)
